export default {
  title: 'Express Rate Management',
  createTitle: 'New Express Rate',
  editTitle: 'Edit Express Rate',
  viewTitle: 'View Express Rate',
  copyTitle: 'Copy Express Rate',
  tabs: {
    all: 'All',
    express: 'Express',
    ltl: 'LTL',
    ftl: 'FTL'
  },
  filters: {
    supplierEnterprise: 'Supplier',
    priceNo: 'Rate No.',
    batchNo: 'Generated Batch No.',
    loadMode: 'Load Mode',
    supplier: 'Express Carrier',
    billingModel: 'Billing Model',
    origin: 'Origin Country',
    destination: 'Destination Country',
    source: 'Source',
    billingMethod: 'Billing Method',
    cargoType: 'Cargo Type',
    routeType: 'Route Type',
    office: 'Office',
    accountNo: 'Account',
    serviceType: 'Service Type',
    status: 'Status'
  },
  columns: {
    supplierEnterprise: 'Supplier',
    priceNo: 'Rate No.',
    source: 'Source',
    loadMode: 'Load Mode',
    office: 'Office',
    supplier: 'Express Carrier',
    accountNo: 'Account',
    serviceType: 'Service Type',
    cargoType: 'Cargo Type',
    volumetricFactor: 'Volumetric Factor',
    origin: 'Origin',
    destination: 'Destination',
    billingModel: 'Billing Model',
    billingMethod: 'Billing Method',
    billingDetail: 'Billing Detail',
    surchargeCount: 'Surcharge',
    routeType: 'Route Type',
    minBillingWeight: 'Minimum Billing Weight',
    pickupFee: 'Pickup Fee',
    deliveryFee: 'Delivery Fee',
    loadingFee: 'Loading Fee',
    vehicleType: 'Vehicle Type',
    vehicleCapacity: 'Vehicle Capacity',
    vehicleVolume: 'Vehicle Volume',
    tripPrice: 'FTL Trip Price',
    kmPrice: 'Kilometer Price',
    minKm: 'Minimum KM',
    currency: 'Currency',
    validity: 'Validity',
    status: 'Status',
    actions: 'Actions'
  },
  fields: {
    supplierEnterprise: 'Supplier',
    priceNo: 'Rate No.',
    source: 'Source',
    relatedNo: 'Related No.',
    office: 'Office',
    supplier: 'Express Carrier',
    accountNo: 'Account',
    loadMode: 'Load Mode',
    serviceType: 'Service Type',
    cargoType: 'Cargo Type',
    specialPriceStatus: 'Special Price Status',
    validPeriod: 'Validity',
    beginDate: 'Effective Date',
    endDate: 'Expiry Date',
    currency: 'Currency',
    paymentTerm: 'Payment Term',
    volumetricFactor: 'Volumetric Factor',
    minBillingWeight: 'Minimum Billing Weight',
    pickupFee: 'Pickup Fee',
    deliveryFee: 'Delivery Fee',
    loadingFee: 'Loading Fee',
    vehicleType: 'Vehicle Type',
    vehicleCapacity: 'Vehicle Capacity',
    vehicleVolume: 'Vehicle Volume',
    billingModel: 'Billing Model',
    billingMethod: 'Billing Method',
    firstWeightThreshold: 'First Weight (KG)',
    firstWeightPrice: 'First Price',
    additionalWeightUnit: 'Additional Unit (KG)',
    additionalWeightPrice: 'Additional Price',
    weightTierAdditionalWeightPrice: 'Additional Weight Unit Price',
    unitPrice: 'Unit Price',
    unitPriceVolume: 'Unit Price (per m³)',
    minCharge: 'Minimum Charge',
    weightTierMinCharge: 'Minimum Charge (Total Price)',
    pricingMethod: 'FTL Pricing Method',
    tripPrice: 'Trip Price',
    kmPrice: 'KM Price',
    minKm: 'Minimum KM',
    weightStart: 'Weight Start',
    weightEnd: 'Weight End',
    sortOrder: 'Sort',
    remarks: 'Remarks',
    billingRemark: 'Billing Remark',
    onePriceAmount: 'One-price Total',
    onePriceIncludedItems: 'One-price Included Items',
    onePriceRemarks: 'One-price Remarks',
    originAddress: 'Origin',
    destinationAddress: 'Destination',
    warehouse: 'Warehouse',
    surchargeName: 'Fee Name',
    surchargeBillingMode: 'Billing Mode',
    surchargeValue: 'Amount/Percentage',
    surchargeUnit: 'Unit',
    surchargeMinCharge: 'Minimum Charge',
    surchargePaymentType: 'Payment Term',
    isCountTotal: 'Count In Total',
    isTotalIncluded: 'Included',
    surchargeSource: 'Fee Source'
  },
  sections: {
    basicInfo: 'Basic Information',
    routeInfo: 'Route Information',
    billingInfo: 'Billing Rule',
    billingDetail: 'Billing Detail',
    ltlFields: 'LTL Information',
    ftlFields: 'FTL Information',
    surcharge: 'Surcharge Details',
    remark: 'Remarks'
  },
  placeholders: {
    supplierEnterprise: 'Select supplier',
    priceNo: 'Enter rate no.',
    batchNo: 'Enter generated batch no.',
    source: 'Select source',
    relatedNo: 'Enter related no.',
    office: 'Select office',
    supplier: 'Select express carrier',
    accountNo: 'Enter account',
    loadMode: 'Select load mode',
    origin: 'Select origin country',
    destination: 'Select destination country',
    serviceType: 'Select service type',
    surchargeName: 'Enter fee name',
    surchargePaymentType: 'Select payment term',
    cargoType: 'Select cargo type',
    routeType: 'Select route type',
    validPeriod: 'Select validity',
    beginDate: 'Select effective date',
    endDate: 'Select expiry date',
    currency: 'Select currency',
    paymentTerm: 'Select payment term',
    billingModel: 'Select billing model',
    billingMethod: 'Select billing method',
    status: 'Select status',
    specialPriceStatus: 'Select special price status',
    number: 'Enter number',
    optional: 'Optional',
    unlimited: 'Leave blank for no upper limit',
    text: 'Enter',
    remarks: 'Enter remarks',
    billingRemark: 'Enter billing remark',
    warehouse: 'Select warehouse'
  },
  actions: {
    add: 'New Rate',
    import: 'Import',
    export: 'Export',
    downloadTemplate: 'Download Template',
    batchOperations: 'Batch Operations',
    batchPublish: 'Batch Publish',
    batchOffline: 'Batch Offline',
    batchDelete: 'Batch Delete',
    view: 'Details',
    edit: 'Edit',
    copy: 'Copy',
    publish: 'Publish',
    offline: 'Offline',
    delete: 'Delete',
    more: 'More',
    reset: 'Reset',
    saveDraft: 'Save Draft',
    cancel: 'Cancel',
    confirm: 'Confirm',
    addTier: 'Add Tier',
    addSurcharge: 'Add Surcharge'
  },
  enums: {
    specialPriceStatus: {
      1: 'Special price not allowed',
      2: 'Special price allowed',
      3: 'Special price'
    },
    source: {
      1: 'Manual',
      2: 'Excel Import',
      3: 'Inquiry Import',
      4: 'Bid Import'
    },
    loadMode: {
      EXPRESS: 'Express',
      LTL: 'LTL',
      FTL: 'FTL'
    },
    billingModel: {
      FIRST_ADDITIONAL: 'First + Additional',
      UNIT_PRICE: 'Unit Price',
      WEIGHT_TIER: 'Weight Tier'
    },
    billingMethod: {
      WEIGHT: 'By Weight',
      VOLUME: 'By Volume',
      WEIGHT_VOLUME_MAX: 'Weight/Volume Max',
      TICKET: 'By Ticket',
      PIECE: 'By Piece',
      TRIP: 'By Trip',
      KM: 'By KM'
    },
    paymentTerm: {
      PREPAID: 'Prepaid',
      COLLECT: 'Collect'
    },
    routeType: {
      DOMESTIC: 'Domestic',
      INTERNATIONAL: 'International',
      PENDING: 'Pending'
    },
    serviceType: {
      express: 'Express',
      standard: 'Standard',
      economy: 'Economy',
      priority_freight: 'Priority Freight',
      economy_freight: 'Economy Freight',
      deferred_freight: 'Deferred Freight',
      DHL_EXPRESS_WORLDWIDE: 'DHL Express Worldwide',
      DHL_EXPRESS_WORLDWIDE_EXPORT: 'DHL Express Worldwide Export',
      DHL_EXPRESS_WORLDWIDE_IMPORT: 'DHL Express Worldwide Import',
      DHL_EXPRESS_WORLDWIDE_THIRD_COUNTRY: 'DHL Express Worldwide Third Country',
      DHL_ECONOMY_SELECT: 'DHL Economy Select',
      FEDEX_INTERNATIONAL_PRIORITY: 'FedEx International Priority',
      FEDEX_INTERNATIONAL_ECONOMY: 'FedEx International Economy',
      UPS_WORLDWIDE_EXPRESS: 'UPS Worldwide Express',
      UPS_WORLDWIDE_SAVER: 'UPS Worldwide Saver',
      SF_STANDARD_EXPRESS: 'SF Standard Express',
      SF_ECONOMY_EXPRESS: 'SF Economy Express',
      STANDARD_EXPRESS: 'Standard Express',
      ECONOMY_EXPRESS: 'Economy Express'
    },
    surchargeBillingMode: {
      FIXED: 'Fixed Amount',
      PERCENTAGE: 'Percentage'
    },
    surchargePaymentType: {
      PREPAID: 'Prepaid',
      COLLECT: 'Collect',
      PREPAID_OR_COLLECT: 'Prepaid/Collect'
    },
    surchargeSource: {
      manual: 'Manual',
      system: 'System Rule'
    },
    boolean: {
      true: 'Yes',
      false: 'No'
    },
    status: {
      1: 'Draft',
      2: 'Normal',
      3: 'Expired',
      4: 'Offline',
      5: 'Disabled',
      6: 'Pending Import'
    }
  },
  routeTypeDescriptions: {
    DOMESTIC: 'Origin and destination countries are the same. The route is handled as domestic express.',
    INTERNATIONAL: 'Origin and destination countries are different. The route is handled as international express.',
    PENDING: 'Select origin and destination countries to infer the route type.'
  },
  billingDetail: {
    firstWeight: 'First Weight',
    additionalWeight: 'Additional Weight',
    tier: 'Tier {index}',
    tierCount: '{count} tiers',
    noLimit: 'No Limit'
  },
  messages: {
    sourceEditDisabled: 'Only manually entered or Excel-imported express rates can be edited.',
    fetchFailed: 'Failed to load express rates',
    loadDetailFailed: 'Failed to load express rate detail',
    loadDefaultOfficeFailed: 'Failed to load the default branch. Please select a branch manually.',
    loadCargoTypesFailed: 'Failed to load express cargo types. Please try again later.',
    saveSuccess: 'Draft saved',
    publishSuccess: 'Rate published',
    offlineSuccess: 'Rate offlined',
    deleteSuccess: 'Deleted successfully',
    batchPublishSuccess: 'Batch publish successful',
    batchOfflineSuccess: 'Batch offline successful',
    batchDeleteSuccess: 'Batch delete successful',
    noSelection: 'Select rates first',
    onlyDraftCanPublish: 'Only Draft can be published. Selection: {status}',
    onlyNormalCanOffline: 'Only Normal can be offlined. Selection: {status}',
    deleteConfirm: 'Are you sure to delete this rate?',
    batchDeleteConfirm: 'Delete selected rates? This cannot be undone.',
    importTitle: 'Import Express Rates',
    importSelectFile: 'Click or drag to upload an Excel file',
    importParsing: 'File uploaded. Creating import task...',
    importSubmit: 'Start Import',
    importReminderTitle: 'Import Notes',
    importReminderAsync: 'An async task will be created after upload. Check the parsing result in Task Management.',
    importReminderWarning: 'Package type, transport term and surcharge name are not imported in this release; non-empty values will be shown as warnings.',
    templateDownloadFailed: 'Template download failed',
    uploadSuccess: 'Import task created',
    uploadFailed: 'Upload failed. Please try again later',
    detailAddressRequired: 'Select a warehouse or enter a detail address for both origin and destination',
    weightTierRequired: 'At least one weight tier is required',
    weightTierPriceModeInvalid: 'In weight tier row {index}, enter either unit price (optional additional weight price) or minimum charge (total price), and leave unused price fields blank',
    weightTierRangeInvalid: 'Weight tier row {index} is invalid, overlaps another row, or has a non-final open end',
    weightTierConfigNotFound: 'No weight tier is configured for this express carrier and service type. Please maintain it manually',
    ftlOnlyUnitPrice: 'FTL mode only supports unit-price billing',
    tripPriceRequired: 'Enter FTL trip price',
    kmPriceRequired: 'Enter kilometer price',
    surchargeAtLeastOne: 'At least one surcharge is required',
    surchargeNameRequired: 'Select the fee name for surcharge row {row}',
    surchargeBillingModeRequired: 'Select the billing mode for surcharge row {row}',
    surchargeValueRequired: 'Enter the price configuration for surcharge row {row}',
    surchargeUnitRequired: 'Select the unit for surcharge row {row}',
    surchargeCurrencyRequired: 'Select the currency for surcharge row {row}',
    surchargePaymentTypeRequired: 'Select the payment term for surcharge row {row}',
    surchargeCountTotalRequired: 'Select whether surcharge row {row} counts in total',
    surchargeIncludedRequired: 'Select whether surcharge row {row} is included',
    copyTip: 'Rate no. will be regenerated after copying. Confirm and save.',
    onePriceTip: 'This rate was imported from a one-price quotation. Surcharges are not added during calculation.',
    surchargeCount: '{count} surcharges',
    exportFilename: 'Express Rate Data'
  }
}
